import { faHourglass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FunctionComponent } from 'react'

import useStyles from './TimeBox.styles'

export interface TimeBoxProps {
  children: React.ReactNode
}

const TimeBox: FunctionComponent<TimeBoxProps> = ({ children }) => {
  const classes = useStyles()
  return (
    <div className={classes.tipBox}>
      <span className={classes.tipBoxIcon}>
        <FontAwesomeIcon icon={faHourglass} />
      </span>
      {children}
    </div>
  )
}

export default TimeBox
